/* eslint-disable no-console */
import { Divider } from 'antd'
import React, { useEffect } from 'react'
import { Sale } from 'src/core/models'
import { saleListColumns } from 'src/core/table-columns'
import { CustomCard, CustomTable } from 'src/components'
import SaleListHeader from './SaleListHeader/SaleListHeader'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  getSalesList,
  getCurrencyList,
  resetMySalesList,
  salesListSelector,
  setMySalesSelected, selectCurrencyToken
} from 'src/features'

const MySalesPageContent: React.FC = () => {
  const dispatch = useAppDispatch()
  const currency_code = useAppSelector(selectCurrencyToken)
  const { loading, filtered } = useAppSelector(salesListSelector)

  useEffect(() => {
    dispatch(getSalesList(currency_code))
    dispatch(getCurrencyList())
    return (() => {
      dispatch(resetMySalesList())
    })
  }, [dispatch, currency_code])

  const rowSelection = {
    onChange: (_: any, selectedSales: Sale[]) => {
      dispatch(setMySalesSelected(selectedSales))
    },
  }

  return <CustomCard loading={loading}>
    <SaleListHeader salesLength={filtered.length} />
    <Divider />
    <CustomTable
      columns={saleListColumns}
      dataSource={filtered}
      rowKey={(sale: Sale) => sale.id}
      rowSelection={{
        type: 'checkbox',
        ...rowSelection,
      }}
    />
  </CustomCard>

}

export default MySalesPageContent
